import React, { useMemo, useState } from 'react'
import styled from 'styled-components'
import { CommonUtility } from 'utility'

const ReadMoreText = styled.p`
  font-weight: bold;
  ${({ isModal }) =>
    !isModal &&
    `
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-bottom:5px;
    max-width: 250px;
    display: inline-block;
  `}

  .toggle-text {
    color: blue;
    cursor: pointer;
  }
`

export const ReadMoreBox = ({ text, isModal = false }) => {
  const [readMore, setReadMore] = useState(false)

  const displayedText = useMemo(() => {
    if (!isModal) {
      return text
    }
    return readMore ? text : CommonUtility.truncateString(text, 50)
  }, [text, readMore, isModal])

  return (
    <ReadMoreText isModal={isModal}>
      {displayedText}{' '}
      {isModal && text?.length > 50 && (
        <span className="toggle-text" onClick={() => setReadMore(!readMore)}>
          {readMore ? ' Read Less' : ' Read More'}
        </span>
      )}
    </ReadMoreText>
  )
}
